import React from "react";
import { Component } from "react";
// import { Switch } from "react-router-dom";
// import { Draggable, DragDropContext, Droppable } from "react-beautiful-dnd";
// import { getBoundingClientRect } from "../../utils/functions";
import { checkTranslation, chooseFontColor, translate } from "../../utils/useful";
// import LoaderButton from "../LoaderButton";
import FixedView from "../FixedView";
import { FormBuilderObjects } from "../../variables/formBuilderData";
import SidebarView from "../SidebarView";
import importedIcons from "./icons";
import FormViewer from "../FormViewer";
import ButtonAnimated from "../buttons/ButtonAnimated";
// import { nanoid } from "nanoid";
// import React, { useRef, useState } from "react";

export default class OtherComponentFloatConfig extends Component {
  state = {

    fontsize: [
      // { type: 8 },
      // { type: 9 },
      // { type: 10 },
      // { type: 11 },
      { type: 12 },
      { type: 13 },
      { type: 14 },
      { type: 15 },
      { type: 16 },
      { type: 17 },
      { type: 18 },
      { type: 20 },
      { type: 24 },
      { type: 30 },
      { type: 36 },
      { type: 48 },
      // { type: 60 },
      // { type: 72 },
      // { type: 96 },
    ],

    columnSettingsFields: [
      { key: 'style.width', type: 'NumberInput', col: '9', information: { label: '{{lang}}Column width', maxValue: 100, placeholder: '{{lang}}width', required: false }, },

      { key: 'style.widthUnit', type: 'SelectInput', col: '3', information: { label: '\u200B', placeholder: '{{lang}}select', defaultValue: '%', items: [{ title: '%', value: '%' }, { title: 'px', value: 'px' },], emptyNotAllowed: true } },

      { key: 'style.maxWidth', type: 'NumberInput', col: '9', information: { label: '{{lang}}Max width', maxValue: 100, placeholder: '{{lang}}width', required: false }, },

      { key: 'style.maxWidthUnit', type: 'SelectInput', col: '3', information: { label: '\u200B', placeholder: '{{lang}}select', defaultValue: '%', items: [{ title: '%', value: '%' }, { title: 'px', value: 'px' },], emptyNotAllowed: true } },

      { key: 'style.align', type: 'SelectInput', col: '12', information: { label: '{{lang}}Alignment', placeholder: '{{lang}}select', defaultValue: 'center', items: [{ title: '{{lang}}Left', value: 'left' }, { title: '{{lang}}Center', value: 'center' }, { title: '{{lang}}Right', value: 'right' }], emptyNotAllowed: true } },

      { key: 'style.borderRadius', type: 'SidesInput', col: '12', information: { label: '{{lang}}Round corners', inputClass: 'none', placeholder: '{{lang}}Border radius' } },

      { key: 'style.margin', type: 'SidesInput', col: '12', information: { label: '{{lang}}Margin', inputClass: 'none', placeholder: '{{lang}}Margin' } },

      { key: 'style.padding', type: 'SidesInput', col: '12', information: { label: '{{lang}}Padding', inputClass: 'none', placeholder: '{{lang}}Padding' } },

    ],


    actionHeader: [
      { key: 'type', type: 'SelectInput', col: '12', information: { type: "local", items: [{ title: 'view', value: 'view' }, { title: 'open window', value: 'openWindow' }], label: 'action', placeholder: 'Choose...', required: true } },
      {
        key: 'page', type: 'SelectInput', col: '12', information: { label: '{{lang}}pages', type: 'api', address: 'getFrames', filter: { type: 'page' }, fields: { title: 'name', value: '_id' }, placeholder: '{{lang}}pages', required: false }, showMain: false,
        dependencies: [{
          refKey: 'type',
          targetKey: 'page',
          conditions: {
            root: {
              id: 'root',
              action: 'or',
              conditions: {
                1: { id: 1, source: { value: '@data.type' }, operator: { value: '==' }, target: { value: 'openWindow' } },
                // 1: { id: 1, source: { value: '@data.applet' }, operator: { value: '==' }, target: { value: 'frame' } },
              }
            },
          },
          show: true,
          init: true,
        }],
      }

    ],


  };

  componentDidMount() {
    // console.log('OtherComponentFloatConfigprops', this.props)
    // console.log('OtherComponentFloatConfigstate', this.state)
    setTimeout(() => {
      this.setState({ show: true })
    }, 10);
  }

  setData = (key, value, myRef) => {
    if (myRef) {
      myRef.hideView()
    }

    this.props.setData(this.props.header?.key, key, value)
  }


  makeInvisible = () => {
    this.props.makeInvisible(this.props.header?.key, this.props.index)
  }

  changeSelectedTextEffects = (key, value, myRef) => {
    // "colorpicker"
    if (myRef) {
      myRef.hideView()
    }
    this.props.changeSelectedTextEffects({ effectType: key, value: value }, this.props.editorId)

  }

  liveChange = (data, init, key, value, extra) => {

    this.props.setElementSettings(this.props.index, "information.action." + key, value)

  }


  columnSettingsChange = (data, init, key, value, extra) => {

    if (!init) {
      this.props.setRowColSettings(this.props.index, key, value, "column")
    }
  }

  // this.props.setElementSettings(this.props.index, "information." + key, value)

  insetText = (text) => {
    // console.log('insetText', text)
    this.parametersView.hideView()
    this.props.insetText(text.replace('{{lang}}', ''))
  }


  render() {

    let section = {}

    let parents = this.props.section?.parents
    let column
    let row

    if (Array.isArray(parents)) {
      column = parents[parents.length - 1]
      row = parents[parents.length - 2]

    }



    return (


      <>
        <div className={'h-100   d-flex pb-2 ' + (this.props.style?.position ? 'w-100' : '')} style={{ position: this.props.style?.position ?? 'absolute', bottom: this.props.style?.bottom ?? -40, top: this.props.style?.top ?? 'auto', left: 0, zIndex: 1, alignItems: 'flex-end', pointerEvents: 'none' }} onClick={e => e.stopPropagation()}>
          <div className={'card-options-container back-blur flexc w-100 px-1'} style={{ background: this.props.style?.background ?? null, boxShadow: this.props.style?.boxShadow ?? null }}>
            {!this.props.style?.position && (
              <img alt="" onMouseDown={(e) => this.props.startMove(e)} draggable={false} {...this.props.provided?.dragHandleProps} src='/assets/icons/drag-and-drop.svg' height={14} className={"builder-options-icon px-1 " + (this.props.dontInvert ? '' : 'invert')} />
            )}
            <img alt="" ref={(el) => (this.configBut = el)} onClick={(e) => this.props.showConfig(e)} src='/assets/icons/useful/settings.png' height={14} className={"builder-options-icon px-1 " + (this.props.dontInvert ? '' : 'invert')} />


            {!this.props.isToolbar && (
              <>
                <div className='mx-2' style={{ height: 16, width: 1, backgroundColor: this.props.dontInvert ? '#00000050' : '#ffffff50' }}>
                </div>


                <img alt="" ref={(el) => (this.rowSettingsBut = el)} onClick={() => this.columnSettingsView.showView()} src='/assets/icons/useful/row.png' height={14} className={"builder-options-icon   px-1 " + (this.props.dontInvert ? '' : 'invert')} />

                <img alt="" ref={(el) => (this.columnSettingsBut = el)} onClick={() => this.columnSettingsView.showView()} src='/assets/icons/useful/column.png' height={14} className={"builder-options-icon   px-1 " + (this.props.dontInvert ? '' : 'invert')} />

                {/* <img alt="" onClick={(e) => { e.stopPropagation(); this.makeInvisible(e, section) }} src='/assets/icons/useful/trash-o.svg' height={14} className={"builder-options-icon   " + (this.props.dontInvert ? '' : 'invert')} /> */}
                <img alt="" onClick={(e) => this.props.duplicateElement(e)} src='/assets/icons/useful/duplicate.svg' height={14} className={"builder-options-icon  px-1 " + (this.props.dontInvert ? '' : 'invert')} />

                <img alt="" onClick={(e) => this.props.doRemoveElement(e)} src='/assets/icons/useful/trash-o.svg' height={14} className={"builder-options-icon  px-1 " + (this.props.dontInvert ? '' : 'invert')} />

              </>
            )}
          </div>
        </div>




        {this.state.show && (
          <>

            <FixedView zIndex={10} ref={(el) => (this.columnSettingsView = el)} nodeRef={this.columnSettingsBut} xOffset={-10} bottomOffset={0} topOffset={0} maxWidth={300} width={300}  >
              <div className="bg-white br-10 p-1 shadow-3 w-100" onClick={e => e.stopPropagation()}>
                <div className=" p-1 sc-gray2" style={{ maxHeight: "250px", overflowY: "auto" }}   >
                  <div className="flexcc flex-column w-100 px-1 py-2" >

                    <FormViewer ref={el => this.form = el} initData={column} headers={this.state.columnSettingsFields} formClass="modern" inputClass={'modern-input'} nopadding={true} liveChange={this.columnSettingsChange} />

                  </div>
                </div>
              </div>
            </FixedView>

          </>

        )}


      </>

    );
  }
}

// export default OtherComponentFloatConfig;
